import { FC } from 'react'
import { useLocation } from 'react-router'
import styled from 'styled-components'

import useReduxSelector from 'hooks/useReduxSelector'
import { media, mediaMax } from 'styles/media'

import Desktop from './Desktop'
import Mobile from './Mobile'
import {
  heightSmall,
  heightLarge,
  navbarSizeBreakpoint,
  zIndex,
} from './constants'

const MobileOnly = styled.div`
  height: 100%;
  width: 100%;

  ${media[navbarSizeBreakpoint]`
    display: none;
  `}
`

const DesktopOnly = styled.div`
  height: 100%;
  width: 100%;

  ${mediaMax[navbarSizeBreakpoint]`
    display: none;
  `}
`

const Outer = styled.div<{ inverse?: boolean; sticky?: boolean }>`
  position: ${({ sticky }) => (sticky ? 'sticky' : 'relative')};
  top: 0;
  width: 100%;
  height: ${heightSmall}px;

  ${media.md`
    height: ${heightLarge}px;
  `}

  z-index: ${zIndex};

  background-color: ${({ theme, inverse }) =>
    inverse ? 'transparent' : theme['-ds-neutral-100'].value};

  ${({ inverse, theme }) =>
    !inverse &&
    `
    border-bottom: 1px solid ${theme['-ds-neutral-300'].value};
  `}
`

const transparentNavbarRoutes: string[] = []

const Navbar: FC<{}> = () => {
  const { pathname } = useLocation()
  const matchingRoutes = transparentNavbarRoutes.filter(
    (path) => path === pathname
  )

  const inverse = matchingRoutes.length > 0

  const sticky = useReduxSelector((state) => state?.navbar?.sticky)

  return (
    <Outer inverse={inverse} sticky={sticky} className="qa-navbar">
      <MobileOnly>
        <Mobile inverse={inverse} />
      </MobileOnly>

      <DesktopOnly>
        <Desktop inverse={inverse} />
      </DesktopOnly>
    </Outer>
  )
}

export default Navbar
